import { ref, computed } from 'vue';
import DashboardAPI from 'vinctoHome/api/dashboard';

// Estado e normalizacao do payload agregado do Inicio. Tolerante por secao:
// secao ausente (sem permissao / feature off) => widget correspondente some.
export function useHomeDashboard() {
  const data = ref(null);
  const uiFlags = ref({ isLoading: true, error: false, notFound: false });

  const fetchDashboard = async (params = {}) => {
    uiFlags.value.error = false;
    try {
      const response = await DashboardAPI.get(params);
      data.value = response.data || {};
    } catch (error) {
      if (error?.response?.status === 404) uiFlags.value.notFound = true;
      uiFlags.value.error = true;
    } finally {
      uiFlags.value.isLoading = false;
    }
  };

  // Refresh silencioso (useLiveRefresh): nao mexe no isLoading pra nao piscar.
  const refreshDashboard = async (params = {}) => {
    try {
      const response = await DashboardAPI.get(params);
      data.value = response.data || {};
    } catch {
      // mantem os dados atuais; o proximo tick tenta de novo
    }
  };

  const meta = computed(() => data.value?.meta || {});
  const live = computed(() => data.value?.conversations_live || null);
  const summary = computed(() => data.value?.conversations_summary || null);
  const timeseries = computed(() => data.value?.conversations_timeseries || []);
  const agents = computed(() => data.value?.agents || null);
  const kanban = computed(() => data.value?.kanban || null);
  const crmToday = computed(() => data.value?.crm_today || null);
  const segments = computed(() => data.value?.segments || null);
  const activities = computed(() => data.value?.activities || null);
  // Estado de cada area do Painel (locked/empty/active) e contato de quem vende.
  const modules = computed(() => data.value?.modules || {});
  const salesContact = computed(() => data.value?.sales_contact || {});

  return {
    data,
    uiFlags,
    fetchDashboard,
    refreshDashboard,
    meta,
    live,
    summary,
    timeseries,
    agents,
    kanban,
    crmToday,
    segments,
    activities,
    modules,
    salesContact,
  };
}
